const X_AI_KEY_PATTERN = /^xai-[A-Za-z0-9_\-.]+$/;
const X_AI_KEY_PREFIX = 'xai-';
export const apiKeyValidator = key => {
  if (!key.trim()) {
    return false;
  }
  if (key.startsWith(X_AI_KEY_PREFIX)) {
    return X_AI_KEY_PATTERN.test(key);
  }
  return false;
};